export const pop = {
  popCouponBuv: '1221.0', // 优惠券-领取按钮点击UV,PV
  popLeftNavUv: '1222.0', // 左侧分类导航--点击UV,PV
  popGoShoppingCart: '1227.0', // 点击购物车按钮.
  goShopDetail: '1223.0', // 点击商品跳详情页
  plusShoppingCart: '1224.0', // 点击加号添加到购物车
  minusShoppingCart: '1226.0', // 点击减号添加到购物车
  popIm: '8780.0',
  goodExpose: '8418.0' // POP店铺-首页-SKU商品曝光
}
